import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import Input from "antd/es/input/Input";
import DeleteConfirmationModal from "../../../components/Modal/UnDeleteConfirmation";
import { Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";

const IncomingTransfer = (props) => {
  let selectData = [];
  const Location = localStorage.getItem("Location");

  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("asc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState();
  const [selectedReceivingCheckboxIds, setselectedReceivingCheckboxIds] =
    useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);

  // console.log("selectedReceivingCheckboxIds", selectedReceivingCheckboxIds);
  const handleReceipt = (pID) => {
    // axios
    //     .get(
    //         `${config.receivingBaseUrl}/receivings/listofsuspendrecordByid?id=${pID}`,
    //         {
    //             headers: {
    //                 "Content-Type": "application/json;charset=UTF-8",
    //                 "Access-Control-Allow-Origin": "*",
    //                 Authorization: token,
    //             },
    //         }
    //     )
    //     .then((res) => {
    //         console.log("res from Suspended Receiving", res);
    //     })
    //     .catch((err) => {
    //         console.log(err);
    //     });
  };

  const handleUnSuspend = (pID) => {
    // console.log("Pid",pID);
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/listofsuspendrecordByid?id=${pID}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res from Suspended Receiving", res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      setSelectedRows(e.selectedRows.map((x) => x.ID));
      selectData[currentPage] = e.selectedRows.map((x) => x.ID);
      console.log(e.selectedRows.map((x) => x.ID));

      const selectedReceivingCheckboxIds =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedReceivingCheckboxIds(selectedReceivingCheckboxIds);
      console.log(selectedReceivingCheckboxIds);
    }
  };

  // Get all tag data
  const handleListData = () => {
    setLoading(true);
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/transferandincomingrequest?locationid=${Location}&status=TRANSFER`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("listofsuspendrecord", res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleListData();
  }, []);

  // const contextActions = useMemo(() => {
  //     const handleDeletePopup = () => {
  //         const deleteRequestParam = {
  //             deliveriesids: selectedReceivingCheckboxIds,
  //         };
  //         localStorage.setItem(
  //             "DeleteRequestParam",
  //             JSON.stringify(deleteRequestParam)
  //         );
  //     };

  //     return (
  //         <button
  //             type="button"
  //             className="btn btn-success btn-sm pull-left "
  //             data-bs-toggle="modal"
  //             data-bs-target="#UnDeleteConfirmationModal"
  //             onClick={handleDeletePopup}
  //         >
  //             <i className="fa fa-trash fa-sm" /> Un Delete
  //         </button>
  //     );
  // }, [data, selectedRows, toggleCleared]);

  // Table Data
  const columns = [
    {
      name: "	Receiving ID",
      selector: "ReceivingId",
      sortable: true,
    },
    {
      name: "Date",
      selector: "Date",
      sortable: true,
    },
    {
      name: "Supplier",
      selector: "Supplier",
      sortable: true,
    },
    {
      name: "Items",
      selector: "Items",
      sortable: true,
    },
    {
      name: "Total",
      selector: "Total",
      sortable: true,
    },
    {
      name: "Amount Paid",
      selector: "AmountPaid",
      sortable: true,
    },

    {
      name: "Amount Due",
      selector: "AmountDue",
      sortable: true,
    },
    {
      name: "Comments",
      selector: "Comments",
      sortable: true,
    },
    {
      name: "Receive Type",
      selector: "ReceiveType",
      sortable: true,
    },
    {
      name: "Unsuspend",
      width: "150px",
      cell: (row) => (
        <Link to={`/receiving/${row.ID}`}>
          <button className="btn btn-primary">Unsuspend</button>
        </Link>
      ),
    },
    {
      name: "Receivings Receipt",
      width: "150px",
      cell: (row) => (
        <Link to={`/receiving-receipt/${row.ID}`}>
          <button onClick={handleReceipt(row.ID)} className="btn btn-primary">
            Receipt
          </button>
        </Link>
      ),
    },
    {
      name: "Email Receipt",
      selector: "EmailReceipt",
      sortable: true,
    },
    {
      name: "Delete",
      width: "100px",
      cell: (row) => (
        <Link
          className="confirm-text"
          to="#"
          title="Delete"
          data-bs-toggle="modal"
          data-bs-target="#DeleteConfirmationModal"
          // onClick={() => handleDeletePopup(row.ID)}
        >
          <i
            className="fa fa-trash text-red fa-2x"
            data-bs-toggle="tooltip"
            title="Delete"
          ></i>
        </Link>
      ),
    },
  ];
  function handleCheckboxChange(columnName) {
    if (hiddenColumns.includes(columnName)) {
      setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
    } else {
      setHiddenColumns([...hiddenColumns, columnName]);
    }
  }
  // generate new columns according to hiddenColumns data and pass it as datatable column
  const filteredColumns = columns.filter(
    (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  );

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };
  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
    console.log(handleListData);
  };
  // const rowSelectCritera = row => row.fat > 6;

  // const clickHandler = (e) => {
  //     console.log(e.target.id);
  // }
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h3>Suspended Receiving</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/receiving">Receiving List</Link>
                </li>
                <li className="breadcrumb-item active">
                  Suspended Receiving List
                </li>
              </ul>
            </div>

            <div className="btn-group pull-right ms-2 dropdown">
              <button
                type="button"
                className="btn btn-outline-primary dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ borderRadius: "5px" }}
              >
                <i className="fa fa-cog"></i> &nbsp;
              </button>
              <div className="dropdown-menu">
                {columns.map((column) =>
                  // omit Action column
                  column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                    <div
                      key={column.name.replace(/\s+|-|\/|#/g, "")}
                      className="form-check ms-2 mt-1"
                    >
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`checkbox-${column.name.replace(
                          /\s+|-|\/|#/g,
                          ""
                        )}`}
                        value={column.name.replace(/\s+|-|\/|#/g, "")}
                        checked={
                          !hiddenColumns.includes(
                            column.name.replace(/\s+|-|\/|#/g, "")
                          )
                        } // check all checkboxes which are not include in hiddenColumns
                        onChange={() =>
                          handleCheckboxChange(
                            column.name.replace(/\s+|-|\/|#/g, "")
                          )
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`checkbox-${column.name.replace(
                          /\s+|-|\/|#/g,
                          ""
                        )}`}
                      >
                        {column.name}
                      </label>
                    </div>
                  ) : (
                    ""
                  )
                )}
              </div>
            </div>
          </div>
          <div className="row flex-row-reverse">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              />
              {/* <Input.Search placeholder="Search..." className="search-btn form-control form-control-sm" onChange={ChangeFilterText} /> */}
            </div>
          </div>

          {/* Customer list */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  title="Incoming Transfer"
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  selectableRows
                  sortServer
                  onSort={handleSort}
                  // contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <DeleteConfirmationModal
        deleteApiUrl={`${config.deliveriesBaseUrl}/deliveries/undeletemutiple`}
      />
    </>
  );
};

export default IncomingTransfer;
